import React, { useEffect, useLayoutEffect, useRef } from "react";
import ReactDOM from "react-dom";
import cmsUtils from "../../utils/cmsUtils";
import utils from "../../../utils";

import { useRouter } from "../../../components";

import { handleElementLink } from "../../../components";
import env from "../../../env";
import { Embed } from "../../../site/embed";

//import { Document, Page } from 'react-pdf'
//import { Document, Page } from 'react-pdf/dist/entry.webpack';

export function Html(props) {
  const ver = env.ver;
  const item = props.item;
  //const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};
  const { history } = useRouter();
  //const [ pdfViewPath, setPdfViewPath ] = React.useState(null)
  //console.log('item', item, cmsOption);

  const year = new Date().getFullYear();
  let content = cmsOption.isCmsEdit
    ? cmsUtils.payload(item, "Content")
    : cmsUtils
        .payload(item, "Content")
        .replace(/__year__/g, year)
        .replace(
          "__version__",
          "<a href = '/app' class = 'app_version'> PWA " + ver + "</a>"
        );

  content = content.replace(
    /<h2>&#xA0;<\/h2>/g,
    `<h2 class='empty-line'>&nbsp;</h2>`
  );

  const cssClass = utils.classNames(
    "cms_item",
    "htmlPanel",
    cmsOption.isCmsEdit && "html",
    item.cssClass || item.anchorName || ""
  );

  //let itemElt = (<div dangerouslySetInnerHTML={{ __html: content }}></div>);

  function handleClick(e) {
    let target = "";
    if (e.target.closest("a")) {
      target = e.target.closest("a").getAttribute("target");
    }
    const processed =
      target === "_blank"
        ? handleElementLink(e.target, null)
        : handleElementLink(e.target);
    //const link = utils.url.getLinkFromElement(e.target);
    //console.log('clicked', e, e.target, processed);

    if (processed.handled) {
      e.preventDefault();
      e.stopPropagation();
    } else if (processed.linkInfo && processed.linkInfo.type === "internal") {
      e.preventDefault();
      e.stopPropagation();
      history.push(processed.linkInfo.url);
    } else {
      // e.preventDefault();
      // e.stopPropagation();
      // setPdfViewPath(utils.site.resourcePath(link))

      if (e.target.closest("a")) {
        let href = e.target.closest("a").getAttribute("href") + "";
        if (href.indexOf("#") !== -1) {
          let _href = href.split("#");
          console.log("_href", _href);
          let el = document.querySelector(
            'section[data-cms-item-anchor="' + _href[1] + '"]'
          );
          let anchorStatus = el.getAttribute("data-anchor-status");
          if (anchorStatus === "collapse") {
            el.setAttribute("data-anchor-status", "expand");
            el.classList.add("expand");
          } else {
            el.setAttribute("data-anchor-status", "collapse");
            el.classList.remove("expand");
          }
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  }
  //console.log(pdfViewPath)
  const pdfView =
    // pdfViewPath ?
    // <Document file={pdfViewPath}><Page pageIndex={1}/></Document> :
    null;

  const htmlBlock = useRef(null);
  const lastContentRef = useRef(null);

  useEffect(() => {
    if (cmsOption?.isCmsEdit) {
      window.cmsPrepareBlockForEdit = prepareBlockForEdit;
      window.cmsRestoreBlockEmbeds = (blockEl) => replaceEmbedCodes(blockEl, cmsOption);
      return () => {
        delete window.cmsPrepareBlockForEdit;
        delete window.cmsRestoreBlockEmbeds;
      };
    }
  }, [cmsOption?.isCmsEdit, cmsOption]);

  useLayoutEffect(() => {
    const block = htmlBlock.current;
    if (!block) return;

    // Only set innerHTML when content actually changed, so we don't wipe mounted
    // embeds when the parent re-renders (e.g. after clicking outside).
    if (lastContentRef.current !== content) {
      block.innerHTML = content;
      lastContentRef.current = content;
    }

    replaceEmbedCodes(block, cmsOption);

    const buttons = block.querySelectorAll(".button");
    for (let i = 0; buttons && i < buttons.length; i++) {
      restructureButton(buttons[i]);
    }

    const iframes = block.querySelectorAll("iframe");
    for (let i = 0; iframes && i < iframes.length; i++) {
      resetYoutubeIframe(iframes[i]);
    }
  }, [content, cmsOption]);

  return (
    <>
      <div
        ref={htmlBlock}
        className={cssClass}
        data-cms-html='true'
        data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
        id={item.anchorName}
        onClick={(e) => handleClick(e)}
      />
      {pdfView}
    </>
  );
}

function restructureButton(el) {
  if (!el.querySelector("span")) {
    const span = document.createElement("span");
    span.innerHTML = el.innerHTML;
    el.innerHTML = "";
    el.appendChild(span);
  }
}

function resetYoutubeIframe(el) {
  if (el && el.parentElement) {
    if (
      !(
        el.parentElement.getAttribute("class") &&
        el.parentElement.getAttribute("class").indexOf("ytvideo") >= 0
      )
    ) {
      const div = document.createElement("div");
      div.setAttribute("class", "ytvideo");
      el.parentElement.appendChild(div);
      div.appendChild(el);
    }
  }
}

function replaceEmbedCodes(block, cmsOption) {
  if (!block) return;
  const embedDataList = cmsOption?.pageData?.embedDataList;
  if (!embedDataList || embedDataList.length === 0) return;
  const embedCodes = block.querySelectorAll("img[data-embed-jaba], div[data-embed-jaba]:not([data-cms-embed-placeholder])");
  embedCodes.forEach((embed) => {
    const id = embed.getAttribute("data-embed-jaba");
    const found = utils.array.find(embedDataList, (x) => x.id === id);
    if (found) {
      // Skip if this node already has our embed mounted (avoids unmount/remount on re-render)
      if (embed.tagName === "DIV" && embed.classList.contains("embedCodes")) {
        return;
      }
      if (embed.tagName === "DIV" && embed.querySelector(".embedCodes")) {
        return;
      }
      let container = embed;
      let embedWrapper;
      if (embed.tagName === "IMG") {
        container = document.createElement("div");
        container.setAttribute("data-embed-jaba", id);
        container.setAttribute("data-cms-embed-placeholder", "true");
        const parent = embed.parentNode;
        if (parent) {
          parent.replaceChild(container, embed);
          container.appendChild(embed);
          embed.style.setProperty("display", "none");
        }
        embedWrapper = document.createElement("div");
        container.appendChild(embedWrapper);
        ReactDOM.render(<Embed code={found.code} type={found.codeType} />, embedWrapper);
      } else {
        ReactDOM.render(<Embed code={found.code} type={found.codeType} />, embed);
      }
    }
  });
}

export function prepareBlockForEdit(blockEl) {
  if (!blockEl || !blockEl.querySelectorAll) return;
  const placeholders = blockEl.querySelectorAll("[data-cms-embed-placeholder]");
  placeholders.forEach((container) => {
    const img = container.querySelector("img[data-embed-jaba]");
    const embedRoot = container.lastElementChild;
    if (img && container.parentNode) {
      if (embedRoot) ReactDOM.unmountComponentAtNode(embedRoot);
      img.style.removeProperty("display");
      container.parentNode.insertBefore(img, container);
      container.parentNode.removeChild(container);
    }
  });
}
